module.exports = __webpack_public_path__ + "media/images/actionmeds-ec9c8db1.svg";